module.exports = __webpack_public_path__ + "static/iphone-gem-card-f132ab219736ac1cb75bf7e12cf9af12.png";